import { IconButton } from "@similarweb/ui-components";

export const OvertimeDefaultCell = ({ row }) => {
    return (
        <>
            {!row.parent ? (
                <IconButton
                    iconName="chev-right"
                    type="flat"
                    className="enrich"
                />
            ) : null}
        </>
    );
};
